import {parse, objectHandlers} from '../core/csvreader.js';

var _dsib;

function dictionaryRecordHandler(rec) { 
   this[rec.code] = rec;
   delete rec.code;
   if (rec.parents) {
      rec.parents = JSON.parse(
         rec.parents
            .replace(/^\[(.+)\]$/g,'["$1"]')
            .replace(/,/g,'","')
      );
   }
}

function getDictionaryCSVHandlers() {
   var handlers = Object.assign({}, objectHandlers(
               ['code','labelEN','labelFR','altLabelEN','altLabelFR','parents'],
               ['string','string','string','string','string','string']
            ));

   handlers.record = dictionaryRecordHandler;

   return handlers;
}

export function readDictionary(data, dsibGlobal) {
   _dsib = dsibGlobal;
   try {
      return parse(data, {headers: false}, getDictionaryCSVHandlers(), _dsib.economies);
   } catch(e) {
      console.log(e);
      delete _dsib.economies;
   }
}

function getCodeLabel(code, options) {
   var entry = _dsib && _dsib.economies && _dsib.economies[code], label = options.overrides ? options.overrides[code] : undefined, lang = _dsib.lang;
   if (!entry || label) return label;
   if (options.enabledAltLabel) label = entry['altLabel' + lang];
   if (!label) label = entry['label' + lang];
   return label;
}

export function getParentsFromDictionary(code, options) {
   if (code !== undefined && code != null) {
      var entry = _dsib && _dsib.economies && _dsib.economies[code],
          override = options.overrides ? options.overrides[code] : undefined;
      return (override !== undefined) ? (Array.isArray(override) ? override : [override]) : (entry) ? entry.parents : undefined;
   }
}

export function getLabelFromDictionary(code, options) {
   var label = code;
   if (code !== undefined && _dsib && _dsib.lang) {
      if ((typeof code === 'string' || code instanceof String) && code.startsWith('[') && code.endsWith(']')) {
         try {
            var codes = JSON.parse(code.replace(/^\[(.+)\]$/g,'["$1"]')
                                       .replace(/,/g,'","'));
            if (Array.isArray(codes)) {
               label = '';
               codes.forEach(function(scode, index) {
                  scode = getCodeLabel(scode, options);
                  if (!scode) {
                     throw new Error("OK");
                  }
                  if (index > 0 && (index + 1) < codes.length) {
                     label += ', ';
                  } else if ((index + 1) == codes.length) {
                     label += {EN: ' and ', FR: ' et '}[_dsib.lang];
                  }
                  label += scode
               });
            }
         } catch(e) {
            if (e.message != 'OK') console.log(e);
            label = code;
         }         
      } else {
         label = getCodeLabel(code, options);
      } 
   }
   return (label) ? label : code;
}
